import {fromJS} from "immutable";

export function sellableGroups() {
  return fromJS([
    {group: "water", label: "Water"},
    {group: "dispenser", label: "Dispensers"},
    {group: "extras", label: "Extras"},
    {group: "bundle", label: "Bundles"}
  ])
}

export function stockableGroups() {
  return fromJS([
    {group: "water", label: "Water"},
    {group: "dispenser", label: "Dispensers"},
    {group: "extras", label: "Extras"},
    {group: "packaging", label: "Packaging"}
  ])
}

function skuToGroup(sku) {
  switch(sku.substr(0,3)) {
    case "WAT": return "water";
    case "DPR": return "dispenser";
    case "XRA": return "extras";
    case "BDL": return "bundle";
    default: return "";
  }
}

export function applyGroups(data, skuField, groupField="group") {
  return data.map((item) => {
    return item.set(groupField, skuToGroup(item.get(skuField)));
  })
}